<template>
	<div class="insideBody">
		<el-form ref="userinfo" class="insideorm" :model="userinfo" label-width="1.10rem">
			<el-row>
				<el-col :span="24">
					<el-form-item label="当前头像">
						<div class="conTop clr">
							<div class="img fl" @click="replaceDeg = true">
								<img :src="$store.state.index.avatar" />
								<div class="tit">编辑头像</div>
							</div>
							<div class="text clr">
								<img class="imgs fl" v-if="userinfo.duanwei == 1" src="../../assets/images/top2.png" />
								<img class="imgs fl" v-else-if="userinfo.duanwei == 2" src="../../assets/images/top21.png" />
								<img class="imgs fl" v-else-if="userinfo.duanwei == 3" src="../../assets/images/top22.png" />
								<img class="imgs fl" v-else-if="userinfo.duanwei == 4" src="../../assets/images/top23.png" />
								<img class="imgs fl" v-else-if="userinfo.duanwei == 5" src="../../assets/images/top24.png" />
								<img class="imgs fl" v-else-if="userinfo.duanwei == 6" src="../../assets/images/top25.png" />
								<div class="con clr">
									<div class="tits fl">{{userinfo.duanweistr}}</div>
									<div class="smt fl">
										<div class="names">距升级还差 {{userinfo.jifencz}} 积分</div>
										<div class="progress">
											<el-progress color="#0cb1a6" :show-text="false" :percentage="userinfo.jindubi*100"></el-progress>
										</div>
										<div class="name">
											<span>积分：{{userinfo.jifen}} </span>
											<span>全国排名：{{userinfo.paiming}} 名</span>
										</div>
									</div>
									<div class="tits fl">{{userinfo.nextduanweisrt}}</div>
								</div>
							</div>
						</div>
					</el-form-item>
				</el-col>
			  <el-col :span="12">
					<el-form-item label="学号">
					  <el-input type="text" v-model="userinfo.userid" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
			  <el-col :span="12">
					<el-form-item label="城市">
					  <el-input type="text" v-model="userinfo.city"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="姓名" class="red">
					  <el-input type="text" v-model="userinfo.username" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="性别">
					  <el-radio-group v-model="userinfo.sex">
							<el-radio :label="1">男生</el-radio>
							<el-radio :label="2">女生</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="密码" class="red">
					  <el-input type="password" v-model="userinfo.pwd"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="微信/qq">
					  <el-input type="text" v-model="userinfo.wx"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="学段">
						<el-select :disabled="true" v-model="userinfo.xueduan" filterable placeholder="请选择">
							<el-option label="小学" value="xx"></el-option>
							<el-option label="初中" value="cz"></el-option>
							<el-option label="高中" value="gz"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="在读班级">
					  <el-input type="text" v-model="userinfo.class" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="有效期">
					  <el-input type="text" v-model="userinfo.duetime" :disabled="true"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="手机">
					  <el-input type="text" v-model="userinfo.mobile"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="开通版块">
					  <div class="plate clr">
							<div class="list" v-for="(item,index) in modules" :key="index">{{item}}</div>
						</div>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<div class="preser">
						<div class="button" @click="modifyuserinfo">保存</div>
					</div>
				</el-col>
			</el-row>
		</el-form>
		<div class="replaceImage" :class="replaceDeg ? 'on':''">
			<div class="portraitcon">
				<div class="tit clr">
					<div class="name fl">更换头像</div>
					<div class="btn fr" @click="replaceDeg = false"></div>
				</div>
				<div class="portrait">
					<!-- <img src="../../assets/images/top3.png"> -->
					<vueCropper
					  ref="cropper"
					  :img="avatar"
						:info="true"
						:fixed="true"
						:autoCrop="true"
						outputType="png"
						autoCropWidth="1000"
						autoCropHeight="1000"
					></vueCropper>
					<div class="text">
						<el-upload
							action=""
							name="File"
							class="upload-demo"
							ref="upload"
							:show-file-list="false"
							:limit="1"
							accept="image/png,image/gif,image/jpg,image/jpeg"
							:auto-upload="false"
							:on-change="changeUpload"
							>
							<div class="button">上传本地图片</div>
						</el-upload>
					</div>
				</div>
				<div class="bot">
					<div class="tits">选择推荐头像：</div>
					<div class="swiperCont">
						<div class="swiper-container">
							<ul class="swiper-wrapper">
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/boy1.jpg'))">
									<img src="../../assets/images/boy1.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/boy2.jpg'))">
									<img src="../../assets/images/boy2.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/boy3.jpg'))">
									<img src="../../assets/images/boy3.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/girl1.jpg'))">
									<img src="../../assets/images/girl1.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/girl2.jpg'))">
									<img src="../../assets/images/girl2.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/girl3.jpg'))">
									<img src="../../assets/images/girl3.jpg" />
								</li>
								<li class="swiper-slide" @click="swiperFun(require('../../assets/images/photo.png'))">
									<img src="../../assets/images/photo.png" />
								</li>
							</ul>
						</div>
						<div class="swiper-button-next"></div>
						<div class="swiper-button-prev"></div>
					</div>
				
				</div>
				<div class="btnlist">
					<div class="determine" @click="defineButton">确定</div>
					<div class="cancel" @click="replaceDeg = false">取消</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {modifyuserinfo,modifyavatar} from '@/api/control6'
import {VueCropper} from 'vue-cropper';
import Swiper from 'swiper'; 
import '../../css/swiper.min.css'
export default {
  data(){
    return {
			height: null,
			replaceDeg: false,
			userinfo: JSON.parse(JSON.stringify(this.utils.storageGet("userinfo"))),
			modules:[],
			avatar: this.$url+JSON.parse(JSON.stringify(this.utils.storageGet("userinfo"))).avatar+'?img='+new Date().getTime()
		};
	},
	created(){
		var that = this,modules = that.userinfo.modules;
		that.modules = modules.split('|');
	},
	filters: {
	  values(value){
	    return 
	  },
	},
	methods:{
		modifyuserinfo(){
			var that = this;
			that.$refs['userinfo'].validate((valid,object) => {
			  if (valid) {
					modifyuserinfo({
						userid: that.userinfo.userid,
						pwd: that.userinfo.pwd,
						city: that.userinfo.city,
						sex: that.userinfo.sex,
						mobile: that.userinfo.mobile,
					}).then(res => {
						that.utils.storageRemove("userinfo");
						that.utils.storageSet("userinfo",that.userinfo);
						that.$message.success('保存成功');
					});
			  } else {
			    
			  }
			});
		},
		swiperFun(name){
			this.avatar = name;
		},
		changeUpload(file, fileList) {
			this.avatar = URL.createObjectURL(file.raw);
			this.$refs.upload.clearFiles();
		},
		defineButton(){
			var that = this;
			that.$refs.cropper.getCropData((data) => {
				var srt = data.substring(data.indexOf('base64,')+7);
				modifyavatar({
					userid: that.userinfo.userid,
					type: 2,
					avatar: srt
				}).then(res => {
					that.replaceDeg = false;
					that.$store.dispatch('avatar', this.$url+that.userinfo.avatar+'?img='+new Date().getTime());
					that.$message.success('修改图像成功');
				});
			})
		}
	},
	mounted(){
		var that = this;
		that.$nextTick(function(){
			var swiper = new Swiper('.swiper-container', {
			  slidesPerView: 6,
				spaceBetween: 1,
				observer:true,
				observeParents:true,
			  navigation: {
			    nextEl: '.swiper-button-next',
			    prevEl: '.swiper-button-prev',
			  }
			});
		});
		
	},
	components: {
		VueCropper
	},
}
</script>
<style scoped>
	
</style>